import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home';
import Login from '../views/Login';
import Lost from '../views/Lost';
import PasswordReset from '../views/PasswordReset';
import PasswordResetConfirm from '../views/PasswordResetConfirm';
import Register from '../views/Register';
// import VerifyEmail from '../views/VerifyEmail';

import store from '../store';
import DiscountCodes from "@/views/DiscountCodes";
import {BUY, CUSTOM_PERIOD, DISCOUNT_CODES, EXPORT, PAYMENTS, INTERNAL_STATISTICS} from "@/router/router_constants";
import Payments from "@/views/Payments";
import Export from "@/views/Export";
import CustomPeriod from "@/views/CustomPeriod";
import BuyView from "@/views/BuyView";
import InternalStatisticsView from "@/views/InternalStatisticsView";

// const requireAuthenticated = (to, from, next) => {
//   store.dispatch('auth/initialize')
//       .then(() => {
//         if (!store.getters['auth/isAuthenticated']) {
//           next('/login');
//         } else {
//           next();
//         }
//       });
// };

const requireUnauthenticated = (to, from, next) => {
      if (store.getters['auth/isAuthenticated']) {
        next({ name: 'Home' });
      } else {
        next();
      }
  // store.dispatch('auth/initialize')
  //     .then(() => {
  //       if (store.getters['auth/isAuthenticated']) {
  //         next('/home');
  //       } else {
  //         next();
  //       }
  //     });
};

const redirectLogout = (to, from, next) => {
  store.dispatch('auth/logout')
      .then(() => next('/login'));
};

Vue.use(VueRouter)

  const routes = [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/ticket_types',
      name: 'Ticket types',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '../components/TicketTypes.vue')
    },
    {
      path: '/accounting',
      name: 'Accounting',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: Home,
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Home,
    },
    {
      path: '/home',
      component: Home,
      // beforeEnter: requireAuthenticated,
    },
    {
      path: '/day_view',
      component: Home,
    },
    {
      path: CUSTOM_PERIOD,
      component: CustomPeriod,
    },
    {
      path: '/password_reset',
      component: PasswordReset,
    },
    {
      path: '/password_reset/:uid/:token',
      component: PasswordResetConfirm,
    },
    {
      path: '/register',
      component: Register,
    },
    {
      path: DISCOUNT_CODES,
      component: DiscountCodes,
    },
    {
      path: PAYMENTS,
      component: Payments,
    },
    {
      path: EXPORT,
      component: Export,
    },
    {
      path: BUY,
      component: BuyView,
    },
    {
      path: INTERNAL_STATISTICS,
      component: InternalStatisticsView,
    },
    {
      path: '/login',
      component: Login,
      name: 'Login',
      beforeEnter: requireUnauthenticated,
    },
    {
      path: '/logout',
      beforeEnter: redirectLogout,
    },
    {
      path: '*',
      component: Lost,
    },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name !== 'Login' && !store.state.auth.loggedIn && !store.state.auth.loadingApp) {
    console.log(store.state.auth.loadingApp);
    next({ name: 'Login' });
  }
  else {
    next();
  }
})

export default router
